import React from 'react';
import { renderHtmlNode } from './html-renderer';
import { parseHtmlNode } from './html-parser';
import { generateDecoratorNode } from '../../utils/generateDecoratorNode';
import { HtmlNodeComponent } from './HtmlNodeComponent';

export class HtmlNode extends generateDecoratorNode({
  nodeType: 'html',
  properties: [{ name: 'html', default: '', urlType: 'html' }],
}) {
  static importDOM() {
    return parseHtmlNode(this);
  }

  exportDOM(options = {}) {
    return renderHtmlNode(this, options);
  }

  isEmpty() {
    return !this.__html;
  }

  decorate() {
    return <HtmlNodeComponent html={this.__html} nodeKey={this.getKey()} />;
  }
}

export function $createHtmlNode(dataset) {
  return new HtmlNode(dataset);
}

export function $isHtmlNode(node) {
  return node instanceof HtmlNode;
}
